export enum AsyncStateEnum {
  FINISHED = 'FINISHED',
  ERROR = 'ERROR OCCURRED',
  IN_PROGRESS = 'IN PROGRESS',
  CONNECTION_ISSUE = 'CONNECTION ISSUE',
}

export type AsyncState = `${AsyncStateEnum}`;
